<template>
  <div>
    <div class="content">
      <div class="md-layout">
        <div
          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
        >
          <md-card class="md-card-plain">
            <md-card-header>
              <h4>
                <b>Mayai Customer Details</b>
              </h4>
            </md-card-header>
          </md-card>
          <h3><Txt :str="companyname" /></h3>

          <md-tabs :md-active-tab="active" md-alignment="left">
            <md-tab
              v-for="customer in customers"
              :id="customer.number"
              :md-label="customer.number"
              :key="customer._id"
            >
              <!--1st row-->
              <div class="md-layout">
                <div class="md-layout-item">
                  <md-card>
                    <md-card-content>
                      <h3 class="pink-underlined">
                        <span style="position:relative;">アカウント情報</span>
                      </h3>
                      <div class="grid-3">
                        <ul>
                          <li>Login Id</li>
                          <li><Txt :str="customer.loginID" /></li>
                        </ul>
                        <ul>
                          <li>Company Name</li>
                          <li><Txt :str="customer.name" /></li>
                        </ul>
                        <ul>
                          <li>Furigana</li>
                          <li><Txt :str="customer.companynamephonetic" /></li>
                        </ul>
                        <ul>
                          <li>Post code</li>
                          <li><Txt :str="customer.postcode" /></li>
                        </ul>
                        <ul>
                          <li>Address</li>
                          <li><Txt :str="customer.companyaddress" /></li>
                        </ul>
                        <ul>
                          <li>Company Phone Number</li>
                          <li><Txt :str="customer.number" /></li>
                        </ul>
                      </div>
                      <hr />
                      <div class="grid-3">
                        <ul>
                          <li>In charge</li>
                          <li><Txt :str="customer.friendlyname" /></li>
                        </ul>
                        <ul>
                          <li>Furigana</li>
                          <li><Txt :str="customer.friendlyname_furigana" /></li>
                        </ul>
                        <ul>
                          <li>Nick name</li>
                          <li><Txt :str="customer.nickname" /></li>
                        </ul>
                        <ul>
                          <li>Person in charge phone number</li>
                          <li><Txt :str="customer.person_phonenumber" /></li>
                        </ul>
                        <ul>
                          <li>Person in charge Email</li>
                          <li><Txt :str="customer.person_email" /></li>
                        </ul>
                      </div>
                    </md-card-content>
                  </md-card>
                </div>
              </div>
              <!--2nd row-->
              <div class="md-layout">
                <div class="md-layout-item">
                  <md-card>
                    <md-card-content>
                      <h3 class="pink-underlined">
                        <span style="position:relative;">050番号</span>
                      </h3>
                      <div class="grid-3">
                        <ul>
                          <li>050 Number</li>
                          <li><Txt :str="customer.number" /></li>
                        </ul>
                        <ul>
                          <li>Pronunciation</li>
                          <li><Txt :str="customer.phone_number_name" /></li>
                        </ul>
                        <ul>
                          <li>Notification Destination</li>
                          <li v-for="notify in customer.notification" :key="notify" >
                            <Txt :str="notify" />
                          </li>
                        </ul>
                      </div>
                    </md-card-content>
                  </md-card>
                </div>
              </div>
              <!--3rd row-->
              <div class="md-layout">
                <div class="md-layout-item">
                  <md-card>
                    <md-card-content>
                      <h3 class="pink-underlined">
                        <span style="position:relative;">プランとあいてむ</span>
                      </h3>
                      <div class="grid-4">
                        <ul>
                          <li>Plan</li>
                          <li><Txt :str="customer.pricing_plan" /></li>
                        </ul>
                        <ul>
                          <li>Status</li>
                          <li><Txt :str="customer.status" /></li>
                        </ul>
                        <ul>
                          <li>Annual Contract</li>
                          <li>
                            <Txt />
                          </li>
                        </ul>
                        <ul>
                          <li>Action</li>
                          <div class="grid-2">
                            <li>
                              <md-dialog-confirm
                                :md-active.sync="isConfirmSleep"
                                md-title="Do you want to change status to `sleep`?"
                                md-confirm-text="Confirm"
                                md-cancel-text="Cancel"
                                @md-cancel="() => {}"
                                @md-confirm="
                                  updateStatus(customer, 'sleep', 'inactive')
                                "
                              />
                              <md-button
                                @click="isConfirmSleep = true"
                                class="button1"
                                >Sleep</md-button
                              >
                            </li>
                            <li>
                              <md-dialog-confirm
                                :md-active.sync="isConfirmCancel"
                                md-title="Do you want to change status to `cancel`?"
                                md-confirm-text="Confirm"
                                md-cancel-text="Cancel"
                                @md-cancel="() => {}"
                                @md-confirm="
                                  updateStatus(customer, 'cancel', 'cancelled')
                                "
                              />
                              <md-button
                                @click="isConfirmCancel = true"
                                class="button1"
                                >Cancel</md-button
                              >
                            </li>
                          </div>
                        </ul>
                      </div>
                      <hr />
                      <div>
                        <ul class="grid-1">
                          <li>Optional Features</li>
                        </ul>
                      </div>
                      <div class="grid-3">
                        <ul>
                          <li style="color: black">Premium Number</li>
                          <li><Txt :str="customer.premium_number" /></li>
                        </ul>
                        <ul>
                          <li style="color: black">Callback</li>
                          <li style="display: inline;"><Txt :str="customer.useAudioCallback" /></li>
                          <li style="display: inline; margin-left: 20px" ><Txt :str="customer.AudioCallbackStatusChangeDate"/></li>
                        </ul>
                        <ul>
                          <li style="color: black">SMS</li>
                          <li style="display: inline"><Txt :str="customer.useSMSConfirm" /></li>
                          <li style="display: inline; margin-left: 20px"><Txt :str="customer.SMSStatusChangeDate" /></li>
                        </ul>
                        <ul>
                          <li style="color: black">Break Setting</li>
                          <li><Txt str="" /></li>
                        </ul>
                        <ul>
                          <li style="color: black">Fan Club</li>
                          <li><Txt str="" /></li>
                        </ul>
                      </div>
                      <hr />
                      <div class="grid-3">
                        <ul>
                          <li>Signup Date</li>
                          <li><Txt :str="new Date(customer.signup_date).toLocaleString()"/></li>
                        </ul>
                        <ul>
                          <li>Trial Date</li>
                          <li><Txt :str="customer.trial_period" /></li>
                        </ul>
                        <ul></ul>
                        <ul>
                          <li>Campaign Period</li>
                          <li><Txt :str="customer.coupons_expiry" /></li>
                        </ul>
                        <ul>
                          <li>Campaign Code</li>
                          <li><Txt :str="customer.coupon_codes" /></li>
                        </ul>
                      </div>
                    </md-card-content>
                  </md-card>
                </div>
              </div>
              <!--4th row-->
              <div class="md-layout">
                <div class="md-layout-item">
                  <md-card>
                    <md-card-content>
                      <h3 class="pink-underlined">
                        <span style="position:relative;">カード</span>
                      </h3>
                      <div class="grid-2">
                        <ul style="margin-top: 3px">
                          <li>Registered Credit Card</li>
                          <li v-if="customer.gmo_cards !== ''">Yes</li>
                          <li v-else>No</li>
                        </ul>
                        <ul style="margin-top: 3px">
                          <li>GMO Number</li>
                          <li><Txt :str="customer.gmo_member_id" /></li>
                        </ul>
                      </div>
                    </md-card-content>
                  </md-card>
                </div>
                <div class="md-layout-item">
                  <md-card>
                    <md-card-content>
                      <h3 class="pink-underlined">
                        <span style="position:relative;">利用音声</span>
                      </h3>
                      <ul>
                        <li>Voice</li>
                        <li><Txt :str="customer.voice" /></li>
                      </ul>
                    </md-card-content>
                  </md-card>
                </div>
              </div>
              <!-- <pre>{{ customer }}</pre> -->
            </md-tab>
          </md-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ApiService from "@/services/ApiService";
import Txt from "@/components/TextHolder";
import moment from "moment";
export default {
  props: {
    customerId: {
      type: String
    }
  },
  data() {
    return {
      isConfirmSleep: false,
      isConfirmCancel: false,
      active: 0,
      companyname: "",
      customers: {
        _id: "",
        name: "",
        loginID: "",
        signup_date: "",
        trial_period: "",
        coupons_expiry: "",
        status: "",
        pricing_plan: "",
        number: "",
        callback: "",
        callback_date: "",
        premium_number: "",
        phone_number_name: "",
        gmo_cards: [],
        companynamephonetic: "",
        notification: "",
        email: "",
        address: "",
        city: "",
        postalcode: "",
        companyaddress: "",
        postcode: "",
        friendlyname: "",
        friendlyname_furigana: "",
        nickname: "",
        person_phonenumber: "",
        person_email: "",
        coupon_codes: "",
        user_data: "",
        voice: "",
        gmo_member_id: "",
        trial_email_title: "",
        email_send_date: "",
        useSMSConfirm: "",
        useAudioCallback: "",
        SMSStatusChangeDate: "",
        AudioCallbackStatusChangeDate: ""
      }
    };
  },
  methods: {
    async updateStatus(company, payload, effect) {
      const { status } = await ApiService.update_mayai_status({
        company_id: company._id,
        status: payload
      });
      if (status <= 200) {
        company.status = effect;
      }
      // console.log('status Code', res)
      // console.log('status Code', response)
    }
  },

  async mounted() {
    const { data } = await ApiService.fetchMayaiCustomerDetails(this.customerId);
    this.customers = data.customers;
    this.active = data.customers[0].number || "";
    this.companyname = data.customers[0].name;

    var user_data = "";
    var loginID = "";
    var friendlyname = "";
    var friendlyname_furigana = "";
    var nickname = "";
    var person_phonenumber = "";
    var person_email = "";
    if (typeof data.customers[0].user_data === "undefined") {
      user_data = user_data.replace("undefined", "");
      friendlyname = "";
    } else {
      // User data inside dataanies collection
      user_data = data.customers[0].user_data;
      loginID = user_data.username;
      friendlyname_furigana = user_data.friendlyname_furigana;
      nickname = user_data.nickname;
      person_phonenumber = user_data.personphonenumber;
      person_email = user_data.personemail;
      if (data.customers[0].user_data.friendlyname === "undefined") {
        friendlyname = "";
      } else {
        friendlyname = data.customers[0].user_data.friendlyname;
      }
    }

    var settings_data = data.customers[0].settings_data;
    var notification = [];
    if (typeof settings_data !== "undefined" && typeof settings_data.template_data !== "undefined") {
      if ( settings_data.template_data.hasOwnProperty("useEmail") && settings_data.template_data.emailAddress.length > 0) {
        for (var i = 0; i < settings_data.template_data.emailAddress.length; i++) {
          notification.push(settings_data.template_data.emailAddress[i]);
        }
        //notification = settings_data.template_data.emailAddress.join(";");
      } else if (settings_data.template_data.useSlack) {
        notification.push(settings_data.template_data.slackChannel + " (Slack)");
      } else if (settings_data.template_data.useSMS) {
        notification.push(settings_data.template_data.smsNumbers[i]);
      }
    }

    var address = "";
    var postalcode = "";
    if (typeof data.customers[0].address !== "undefined") {
      if (data.customers[0].address.hasOwnProperty("address1") && data.customers[0].address.address1.length > 0) {
        //if((typeof data.customers[0].address.address1) && data.customers[0].address.address1.length != 0){
        address = data.customers[0].address.address1;
      }
      if (data.customers[0].address.hasOwnProperty("address2") && address + " " + data.customers[0].address.address2 !== "undefined") {
        address = address + " " + data.customers[0].address.address2;
      }
      if (data.customers[0].address.hasOwnProperty("prefecture") && data.customers[0].address.prefecture !== "undefined") {
        address = address + " " + data.customers[0].address.prefecture;
      }
      if (data.customers[0].address.hasOwnProperty("city") && data.customers[0].address.city !== "undefined") {
        address = address + " " + data.customers[0].address.city;
      }
      if (data.customers[0].address.hasOwnProperty("postcode") && data.customers[0].address.postcode !== "undefined") {
        postalcode = data.customers[0].address.postcode;
      }
    }

    var companyaddress = "";
    var postcode = "";
    if (typeof data.customers[0].companyaddress !== "undefined") {
      companyaddress = data.customers[0].companyaddress;
    }
    if (typeof data.customers[0].postcode !== "undefined") {
      postcode = data.customers[0].postcode;
    }

    var status = data.status;
    if (data.customers[0].status === "active") {
      //this.active++;
      status = "Active";
    } else if (data.customers[0].status === "inactive") {
      //this.inactive++;
      status = "Sleep";
    } else if (data.customers[0].status === "cancelled") {
      status = "Cancel";
    }

    // var coupons = [];
    var coupon_codes = "";
    var coupons_expiry = "";
    if (typeof data.customers[0].coupons !== "undefined" && data.customers[0].coupons.length > 0) {
      // Coupons inside dataanies collection
      if (typeof data.customers[0].coupon_data !== "undefined" && data.customers[0].coupon_data.length > 0) {
        var coupons_data = data.customers[0].coupon_data;
        //Data from coupons collection
        if (data.customers[0].coupons.length >= 1) {
          for (var i = 0; i < data.customers[0].coupons.length; i++) {
            if (data.customers[0].coupons[i].length > 0) {
              var expiry = data.customers[0].coupons[i].expiry !== 0 ? moment(data.customers[0].coupons[i].expiry).format("YYYY/MM/DD") : "Never expires";
              var coupon = coupons_data.filter(c => c._id === data.customers[0].coupons[i].coupon_id);
            }

            if (coupon && coupon.length > 0){
              coupon_codes = coupon_codes + " (" + (i + 1) + ") " + coupon[0].COUPON_CODE;
            }

            coupons_expiry = coupons_expiry + " (" + (i + 1) + ") " + expiry;

            // coupons.push({ code: coupon[0].COUPON_CODE, expiry: expiry });
          }
        }
      }
    }
    var gmo_cards = "";
    if (typeof data.customers[0].gmo_cards !== "undefined" && data.customers[0].gmo_cards.length > 0) {
      if (data.customers[0].gmo_cards[0].hasOwnProperty("CardNo")) {
        gmo_cards = data.customers[0].gmo_cards[0].CardNo;
      }
    }
    var signup_date_str = "";
    if (data.customers[0].email_confirmation_sent) {
      signup_date_str = data.customers[0].email_confirmation_sent;
    } else {
      signup_date_str = data.customers[0].signup_date;
    }
    var trial_period = moment(data.customers[0].signup_date).format("YYYY/MM/DD") + " ~ " + moment(data.customers[0].signup_date).add(data.customers[0].free_period_days, "days").format("YYYY/MM/DD");

    var voice = "";

    if (data.customers[0].agent && data.customers[0].engine) {
      voice = data.customers[0].agent + "-" + data.customers[0].engine;
    } else if (data.customers[0].agent) {
      voice = data.customers[0].agent;
    } else {
      voice = data.customers[0].engine;
    }
    var email_send_date = "";
    if (data.customers[0].trial_email_sent) {
      var email_send_date = moment(data.trial_email_sent).format("YYYY/MM/DD");
    }
    var callback_activated_date = "";
    if (typeof data.customers[0].callback_activated_date === "undefined") {
      callback_activated_date = callback_activated_date.replace("undefined", "");
    } else {
      callback_activated_date = moment(data.customers[0].callback_activated_date).format("YYYY/MM/DD");
    }

    var callback = "";
    if (data.customers[0].hasOwnProperty("rules")) {
      if (data.customers[0].rules.hasOwnProperty("outbound_OK")) {
        if (data.customers[0].rules.outbound_OK === true) {
          callback = "Yes";
        } else {
          callback = "No";
        }
      } else {
        callback = "No";
      }
    } else {
      callback = "No";
    }

    let useSMSConfirm = "";
    let useAudioCallback = "";
    let SMSStatusChangeDate = "";
    let AudioCallbackStatusChangeDate = "";
    const CallbackActivateDate = settings_data.template_data.Callback_activated_date;
    if (settings_data.template_data.useSMSConfirm && settings_data.template_data.useSMSConfirm === true) {
      useSMSConfirm = "on";
    } else {
      useSMSConfirm = "off";
    }
    if (settings_data.template_data.useAudioCallback && settings_data.template_data.useAudioCallback === true) {
      useAudioCallback = "on";
    } else {
      useAudioCallback = "off";
    }
    if ( CallbackActivateDate ) {
      if ( useSMSConfirm == "on" && CallbackActivateDate.SMS.SMS_activated_date ) {
        SMSStatusChangeDate = moment(CallbackActivateDate.SMS.SMS_activated_date).format("YYYY/MM/DD HH:MM:SS");
      } else if ( useSMSConfirm == "off" && CallbackActivateDate.SMS.SMS_deactivated_date ) {
        SMSStatusChangeDate = moment(CallbackActivateDate.SMS.SMS_deactivated_date).format("YYYY/MM/DD HH:MM:SS");
      } else {
        SMSStatusChangeDate = "never used";
      }
      if ( useAudioCallback == "on" && CallbackActivateDate.AudioCallback.AudioCallback_activated_date ) {
        AudioCallbackStatusChangeDate = moment(CallbackActivateDate.AudioCallback.AudioCallback_activated_date).format("YYYY/MM/DD HH:MM:SS");
      } else if ( useAudioCallback == "off" && CallbackActivateDate.AudioCallback.AudioCallback_deactivated_date ) {
        AudioCallbackStatusChangeDate = moment(CallbackActivateDate.AudioCallback.AudioCallback_deactivated_date).format("YYYY/MM/DD HH:MM:SS");
      } else {
        AudioCallbackStatusChangeDate = "never used";
      }
    } else {
      SMSStatusChangeDate = "never used";
      AudioCallbackStatusChangeDate = "never used";
    }
    this.customers = [
      {
        _id: data.customers[0]._id,
        name: data.customers[0].hasOwnProperty("name") ? data.customers[0].name : "",
        loginID: loginID,
        signup_date: signup_date_str,
        trial_period: trial_period,
        coupons_expiry: coupons_expiry,
        status: status,
        pricing_plan: data.customers[0].hasOwnProperty("pricing_plan") ? data.customers[0].pricing_plan : "",
        number: data.customers[0].hasOwnProperty("number") ? data.customers[0].number : "",
        callback: callback,
        premium_number: data.customers[0].number_type_rank,
        callback_activated_date: callback_activated_date,
        phone_number_name: data.customers[0].hasOwnProperty("phone_number_name") ? data.customers[0].phone_number_name : "",
        gmo_cards: gmo_cards,
        companynamephonetic: data.customers[0].hasOwnProperty("companynamephonetic") ? data.customers[0].companynamephonetic : "",
        notification: notification,
        email: data.customers[0].hasOwnProperty("email") ? data.customers[0].email : "",
        address: address,
        companyaddress: companyaddress,
        postcode: postcode,
        friendlyname: friendlyname,
        friendlyname_furigana: friendlyname_furigana,
        nickname: nickname,
        person_phonenumber: person_phonenumber,
        person_email: person_email,
        coupon_codes: coupon_codes,
        user_data: user_data,
        voice: voice,
        gmo_member_id: data.customers[0].hasOwnProperty("gmo_member_id") ? data.customers[0].gmo_member_id : "",
        trial_email_title: data.customers[0].trial_email_title,
        email_send_date: email_send_date,
        useSMSConfirm: useSMSConfirm,
        useAudioCallback: useAudioCallback,
        SMSStatusChangeDate: SMSStatusChangeDate,
        AudioCallbackStatusChangeDate: AudioCallbackStatusChangeDate
      }
    ];
  },
  components: {
    Txt
  }
};
</script>

<style scoped>
ul {
  list-style-type: none;
}
ul > li:first-child {
  font-size: 14px;
  color: rgb(161 161 170);
}
ul > li:not(:first-child) {
  font-size: 14px;
  font-weight: bold;
}
.grid-1 {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  margin-bottom: -5px;
}
.grid-2 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-3 {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.grid-4 {
  display: grid;
  grid-template-columns: 180px 150px 300px auto;
}
.button1 {
  border-radius: 15px;
  font-size: 70%;
  height: 30px;
  width: 45px;
}
.pink-underlined span::after {
  content: " ";
  position: absolute;
  bottom: -3px;
  display: block;
  background-color: pink;
  width: 100%;
  margin-top: 4px;
  height: 4px;
}
</style>